/**
 * Report Issue Button - Report Issue button component
 * Positioned 100px from bottom, draggable vertically
 */

import React, { useState, useRef } from 'react';
import { FloatingButtonDiv, ReportIssueButton as ReportButton, ReportIssueButtonText } from './index.styled';
import ReportIssueForm from './components/ReportIssueForm';
import { isMobileView } from 'src/utils/util';
import { useDraggable } from './components/handlers/useDraggable';
import { japaneseTranslations } from './constants/translations';

export default function ReportIssueButton(props) {
    // Props
    const { error, resetErrorBoundary } = props;

    // Form state
    const [showForm, setShowForm] = useState(false);
    const [showCancelAlert, setShowCancelAlert] = useState(false);
    
    const displayedText = 'Report Issue'; 

    // Refs
    const dragRef = useRef(null);

    const isMobile = isMobileView(); 
    
    // Use draggable hook
    const {
        calculatedBottom,
        isDragging,
        hasDragged,
        handleMouseDown,
        handleTouchStart,
    } = useDraggable(isMobile);

    /**
     * Handle click on Report Issue button
     */
    const reportHandler = (e) => {
        // Only open form if user didn't drag (clicked without dragging)
        if (!hasDragged) {
            setShowForm(true);
        }
        e.stopPropagation();
    };

    return (
    <FloatingButtonDiv isFim={localStorage.getItem('pageName') === 'FieldInventoryDashboard'}>
        {showForm ? (
            <ReportIssueForm
                showForm={showForm}
                setShowForm={setShowForm}
                showCancelAlert={showCancelAlert}
                setShowCancelAlert={setShowCancelAlert}
                error={error}
                resetErrorBoundary={resetErrorBoundary}
                onClose={() => setShowForm(false)}
                japaneseTranslations={japaneseTranslations}
            />
        ) : (
            <ReportButton
                id='report-issue-button'
                ref={dragRef}
                calculatedBottom={calculatedBottom}
                isDragging={isDragging}
                isMobile={isMobile}
                onClick={reportHandler}
                onMouseDown={handleMouseDown}
                onTouchStart={handleTouchStart}
            >
                <ReportIssueButtonText isMobile={isMobile}>
                    {displayedText}
                </ReportIssueButtonText>
            </ReportButton>
        )}
    </FloatingButtonDiv>
    );
}
